import { SxProps, Theme } from "@mui/material";

const styles: Record<string, SxProps<Theme>> = {
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "24px 20px",
        gap: "24px",
        height: "100%",
        overflowY: "auto",
        backgroundColor: "greyscale.50"
    },
    maxWidthContainer: {
        width: "400px"
    },
    heroSection: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px",
        textAlign: "center"
    },
    iconWrapper: {
        width: 56,
        height: 56,
        borderRadius: "16px",
        background: "linear-gradient(135deg, #F31779 0%, #7930D9 50%, #25C0E6 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 1
    },
    heroIcon: {
        width: 56,
        height: 56
    },
    headlineText: {
        background: "linear-gradient(132deg, #F31779 0.9%, #994DBD 64.21%, #25C0E6 127.52%)",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontSize: "18px",
        fontWeight: 600,
        lineHeight: "24px"
    },
    subtitleText: {
        fontSize: "13px",
        lineHeight: "20px",
        color: "greyscale.600",
        maxWidth: 300
    },
    optionToggle: {
        display: "flex",
        width: "400px",
        borderRadius: "10px",
        backgroundColor: "greyscale.100",
        padding: "4px",
        gap: "4px"
    },
    optionTab: {
        flex: 1,
        borderRadius: "8px",
        padding: "8px 8px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "2px",
        border: "2px solid transparent",
        userSelect: "none"
    },
    optionTabActive: {
        background:
            "linear-gradient(white, white) padding-box, linear-gradient(135deg, #F31779, #7930D9, #25C0E6) border-box",
        boxShadow: "0 2px 8px rgba(121, 48, 217, 0.15)"
    },
    optionTabInactive: {
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: "greyscale.200"
        }
    },
    optionTabLabel: {
        fontSize: "13px",
        fontWeight: 600,
        lineHeight: "18px",
        textAlign: "center"
    },
    optionTabLabelActive: {
        background: "linear-gradient(132deg, #F31779 0.9%, #994DBD 64.21%, #25C0E6 127.52%)",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent"
    },
    optionTabLabelInactive: {
        color: "greyscale.600"
    },
    optionTabSubLabel: {
        fontSize: "11px",
        lineHeight: "16px",
        color: "greyscale.500",
        textAlign: "center"
    },
    formCard: {
        width: "100%",
        borderRadius: "12px",
        border: "1px solid",
        borderColor: "greyscale.200",
        backgroundColor: "#fff",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "16px"
    },
    fieldStack: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        width: "100%"
    },
    ollamaModelChip: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px 12px",
        borderRadius: "8px",
        backgroundColor: "greyscale.100",
        border: "1px solid",
        borderColor: "greyscale.300"
    },
    ollamaModelLabel: {
        fontSize: "12px",
        color: "greyscale.500",
        lineHeight: "18px"
    },
    ollamaModelValue: {
        fontSize: "13px",
        fontWeight: 600,
        color: "greyscale.700",
        lineHeight: "18px"
    },
    lockIcon: {
        fontSize: "16px",
        color: "greyscale.400"
    },
    submitButton: {
        width: "100%",
        "& button": {
            width: "100%"
        }
    },
    footerNoteStack: {
        display: "flex",
        flexDirection: "column",
        gap: "4px"
    },
    footerNote: {
        fontSize: "12px",
        color: "greyscale.400",
        textAlign: "center",
        lineHeight: "18px"
    },
    divider: {
        width: "100%",
        height: "1px",
        backgroundColor: "greyscale.200"
    }
};

export default styles;
